<template>
  <div class="fragment">
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--33 custom-col--sm-100"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['common_comment'])"></div>
        <TextareaDefault
            :label="$t('common_comment.localization_value.value')"
            v-model="FBM.data.LeatherStamp.data.comment"
        />
      </div>
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_text'])"></div>
        <DefaultInput
            :label="$t('calculatorEngraving_text.localization_value.value')"
            :type="'text'"
            :placeholder="''"
            v-bind:class="{'ui-no-valid': FBM.data.LeatherStamp.validation.stampingLine}"
            :errorTxt="$t(`${FBM.data.LeatherStamp.validationTranslate.stampingLine}.localization_value.value`)"
            :error="FBM.data.LeatherStamp.validation.stampingLine"
            v-model="FBM.data.LeatherStamp.data.stampingLine"
            @input.native="changeEngravingPrice($event)"
            @change="calculateEngravingPrice"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['calculatorEngraving_product',])"></div>
        <DefaultSelect
            :options="leatherStampCustomOptions"
            :label="$t('calculatorEngraving_product.localization_value.value')"
            :otherValue="'calculatorCustomization'"
            :selected="FBM.data.LeatherStamp.data.customization"
            @change="changeCustomization"
        />
      </div>
      <div class="custom-col custom-col--16 custom-col--sm-50"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate(['fbm_engravingPrice'])"></div>
        <DefaultInput
            :label="$t('fbm_engravingPrice.localization_value.value')"
            :type="'text'"
            :disabled="true"
            v-model="FBM.data.LeatherStamp.data.resultCost"
        />
      </div>
    </div>

    <div
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['fbm_embroideryAcceptFiles'])"></div>
      {{ $t('fbm_engravingAcceptFiles.localization_value.value') }}
    </div>
    <div class="order-create__row custom-row">
      <div class="custom-col position-relative"
           v-if="FBM.data.LeatherStamp.data.File.data.maxCountFiles - Object.keys(FBM.data.LeatherStamp.data.File.data.downloadFiles).length > 0">
        <DropZone class="drop-zone-bg"
                  :parentFiles="FBM.data.LeatherStamp.data.File.data.files"
                  :multiple="true"
                  :maxCount="FBM.data.LeatherStamp.data.File.data.maxCountFiles - FBM.data.LeatherStamp.data.File.data.downloadFiles.length"
                  :maxSize="FBM.data.LeatherStamp.data.File.data.maxSizeFiles"
                  @changeImg="(files, maxSize) => {changeFile(files, maxSize)}"
                  :accept="'/*'"
        />
        <div class="error-field ml-3" v-if="FBM.data.LeatherStamp.data.File.validation.files">
          {{ $t('common_fileIsRequired.localization_value.value') }}
        </div>
      </div>

      <div class="custom-col mt-3"
           v-if="Object.keys(FBM.data.LeatherStamp.data.File.data.downloadFiles).length > 0"
      >
        <div class="custom-row product-img-row">
          <div class="custom-col custom-col--16 custom-col--md-25 custom-col--sm-100"
               v-for="(item, index) in FBM.data.LeatherStamp.data.File.data.downloadFiles"
               :key="index">
            <DownloadFileBlock
                :file="item"
                :customTypeFile="'dfx'"
                @removeFile="(id) => {removeFile(id, index)}"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import DefaultInput from "@/components/UI/inputs/DefaultInput/DefaultInput";
import DownloadFileBlock from "@/components/coreComponents/DownloadFileBlock/DownloadFileBlock";
import DropZone from "@/components/coreComponents/DropZone/DropZone";
import DefaultSelect from "@/components/UI/selectiones/DefaultSelect/DefaultSelect";
import TextareaDefault from "@/components/UI/textarea/TextareaDefault/TextareaDefault";
export default {
  name: "LeatherStamp",
  components: {TextareaDefault, DefaultSelect, DropZone, DownloadFileBlock, DefaultInput},

  props: {
    FBM: Object,
    leatherStampCustomOptions: Array,
  },

  mounted() {

  },

  methods: {

    changeCustomization(val) {
      let oldCustomization = this.FBM.data.LeatherStamp.data.customization
      this.FBM.data.LeatherStamp.data.customization = val
      this.calculateEngravingPrice()
      this.$emit('changeCustomization', oldCustomization, val, 1)
    },

    changeEngravingPrice(event) {
      this.FBM.data.LeatherStamp.data.stampingLine = event.target.value //.replace(',', '.').replace(/[^0-9.]/g, '')
    },

    calculateEngravingPrice() {
      if(this.FBM.data.LeatherStamp.data.stampingLine.length === 0) {
        return
      }

      let data = this.FBM.data.LeatherStamp.prepareData()

      this.$store.dispatch('getLeatherStampCalcOrderResult', data).then(response => {
        if(this.getRespData(response)?.rate) {
          this.FBM.data.LeatherStamp.data.resultCost = parseFloat(this.getRespData(response)?.rate).toFixed(2)
        }
      })
    },

    changeFile(files, maxSizeError) {
      this.FBM.data.LeatherStamp.data.File.setFiles(files)

      this.FBM.data.LeatherStamp.data.File.setFilesMaxSizeError(maxSizeError)

      this.calculateEngravingPrice()
    },

    removeFile(id, index){

      let text = {
        title: 'common_AreYouSure',
        txt: '',
        yes: 'common_confirmDelete',
        no: 'common_confirmNo'
      }

      let confirm = () => {

        let fileKey = Object.keys(this.FBM.data.LeatherStamp.data.File.data.downloadFiles[index])[0]
        if(fileKey) {
          this.FBM.data.removedCustomizationFiles.push(this.FBM.data.LeatherStamp.data.File.data.downloadFiles[index][fileKey]?.uuid)
          this.FBM.data.LeatherStamp.data.File.removeDownloadFile(index)
        }

        // this.$store.dispatch('removeUserDocument', id).then(() => {
        //
        //   this.FBM.data.LeatherStamp.data.File.removeDownloadFile(index)
        //   // this.FBM.data.LeatherStamp.data.File.setDownloadFiles([])
        //
        //   this.calculateEngravingPrice()
        // })

        this.$store.commit('setConfirmDeletePopup', false)
        return true
      }

      this.deleteFunc(text, confirm)


    },
  },

}
</script>

<style scoped>

</style>